import { BaseModel } from './base.model';
import { ResourceModel } from './resource.model';

export class CandidateAcOnlinetestModel extends BaseModel {

  // columns
  status: string;
  hashed_id: string; // tslint:disable-line: variable-name
  login_url: string; // tslint:disable-line: variable-name
  login_user: string; // tslint:disable-line: variable-name
  login_password: string; // tslint:disable-line: variable-name
  comment: string; // tslint:disable-line: variable-name

  // relations
  resources: Array<ResourceModel>;

  deserialize(input: any): this {
    Object.assign(this, super.deserialize(input));
    // reports
    let resources = null;
    if (this.resources !== null && this.resources !== undefined) {
      resources = [];
      this.resources.forEach((resource: ResourceModel) => {
        resources.push(new ResourceModel().deserialize(resource));
      });
    }
    this.resources = resources;
    return this;
  }

  public get hasReports(): boolean {
    return this.resources?.length > 0;
  }

}
